var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#aboutIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 5.87917L19.1102 18.1185H4.8898L12 5.87917ZM3.25624 17.1777C2.52917 18.4289 3.43565 20 4.8898 20H19.1102C20.5644 20 21.4708 18.4289 20.7438 17.1777L13.6336 4.93841C12.9065 3.6872 11.0935 3.6872 10.3664 4.93841L3.25624 17.1777ZM11.0557 10.5924V12.4739C11.0557 12.9913 11.4807 13.4147 12 13.4147C12.5193 13.4147 12.9443 12.9913 12.9443 12.4739V10.5924C12.9443 10.075 12.5193 9.65162 12 9.65162C11.4807 9.65162 11.0557 10.075 11.0557 10.5924ZM11.0557 15.2962H12.9443V17.1777H11.0557V15.2962Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aboutIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/aboutIcon.13fad573964ed6befca440cb27136dde.svg";
export { ForwardRef as ReactComponent };